/* ON3P size engine - the single sizing rule for the whole site.
   Plain script, no dependencies, no module syntax. Exposes one global: window.on3pSize.

   RULE TABLE SOURCE
     Google Sheet "ON3P - Length Finder Sizing Rules" (id 1B29gNaPtKMwcKAmmzxCB5bw8O-3nvT1eBL9mnowOwnA)
     Tab: HEIGHTS   Exported: 2026-09-05   HEIGHTS export: v9   Engine logic: v11
   Scott edits the sheet, one row per inch of height. RULE_TABLE below is a mirror of that tab
   and is regenerated from it. Never hand-edit it: change the sheet, then re-export.

   HOW TO CALL
     window.on3pSize.registerModels([{ handle, family, waistMm, lengths:[161,166,...] }, ...])
       Each surface registers its own models from its own data source, so this file holds the
       RULE only and never a second copy of the spec data. The Length Finder registers from the
       shop metafield on3p.ski_specs; CS-05 registers from its DIMS object. Both derive from the
       Master Sheet, so a handle registered twice carries the same numbers; the later call wins.
     window.on3pSize({ heightIn: 70, weightLb: 175, handle: 'jeffrey-106', rocker: 'Ripper' })
       rocker is optional. Omitted, it means the profile the model is built with, so a stock page
       never has to pass it and never changes.
       -> { primary, secondary, strength, reason, lengths, dir, shortNote, handle, family }
       -> null when the handle is not registered, an input is not a number, or an input is
          outside RULE_TABLE.range.

   v13 (2026-09-10), rocker.
     - Not every shape can be ordered in Ripper. [Scott, 2026-09-10: "The following skis are not
       allowed on ripper. Cease & Desist. Any Billy Goat (down to 102). Jeffrey 124."] Each surface
       says so per model with ripperOk; the engine refuses Ripper on a shape that does not allow
       it and answers as Signature rather than inventing a length.
     - The Ripper ladder applies whenever Ripper is what is being ORDERED, including on the three
       shapes that come that way. That matters for the Woodsman 92: it is built in 166, and
       [Scott, 2026-09-10] "that is a custom ski only available on custom in signature", so the 166
       is reachable on that shape only by choosing Signature.
     - The one-rung step is narrower than the ladder rule: it fires only when Ripper is ordered on
       a shape that is NOT built as Ripper. Choosing Signature on a Ripper shape opens the longer
       ladder but moves no length, because that direction has not been ruled.

   RIPPER_LENGTHS is the hard part: Ripper Rocker is only pressed in
   171, 176, 181, and 186. [Scott, 2026-09-10: "Ripper rocker ONLY exists in....171, 176, 181,
   186."] So choosing Ripper does not only move the answer down a rung, it changes which ladder the
   answer is snapped to, and the existing end-of-ladder handling does the rest: a skier whose
   Ripper length would be 166 is snapped up to the 171 and told it is the shortest built, and one
   whose Ripper length would be 161 is declined, exactly as for any shape not built short enough.

   v13 (2026-09-10), rocker. The rule now takes the rocker profile the skier is ORDERING and
   compares it with the profile the model is BUILT with. They match on every stock page, so a
   stock page reads exactly as it did before. On the custom builder, choosing Ripper Rocker on a
   shape that is not built as Ripper moves the answer one length down that model's own ladder,
   both the lead and the second length, and stops at the shortest length built.
     - The step only ever goes DOWN, and only for Ripper. Choosing Signature on a shape that is
       built as Ripper does nothing. That is deliberately conservative: Scott has ruled the Ripper
       direction ("Someone at 5'10" 165lbs is gonna get a signature 181cm Jeffrey 98, but in
       Ripper rocker they could be 176cm") and has not ruled the inverse.
     - Signature and Signature Pow are one thing for sizing. Signature Pow is a heat-modified
       pressing in the Signature mould, so it deviates from nothing.
     - The three shapes built as Ripper are Jeffrey 92, Woodsman 92, and Oski 102. All eleven of
       Scott's rulings on them stand untouched, which is the whole point of reading the step as a
       deviation rather than as a property of the rocker. [Scott, 2026-09-10, on the Oski 102 at
       5'8" 210 lb: "On a ripper rocker, 181 is probably right." The unadjusted rule says 181.]

   HEIGHTS v10 (2026-09-10). Three flip weights moved, all of them Scott re-ruling a row rather
   than a formula change:
     5'6"  200 -> 185, with the band widened to 24 below and 15 above. [Scott: 5'6" 185 lb on a
           Mango 102 is "176 or 171", not 171 leading; 5'6" 165 lb on a Jeffrey 106 is "171 or
           176"; 5'6" 200 lb stays "176 or 171".]
     5'8"  220 -> 190, with the jump above it at 80 lb rather than 60. [Scott: 170, 175 and 180 lb
           should all see the 181 as an option; 195 lb is "181 makes sense"; 210 lb is "181 is
           probably right"; 220 and 225 lb are "really 181"; and 265 lb stays "181 or 186", which
           is what the longer jump preserves.] This row flipped 42 lb later than 5'9" and was the
           one that produced a 120 lb run of a single headline. It no longer does.
     6'1"  228 -> 220. [Scott: 6'1" 205 lb on a Jeffrey 118 is "191 or 186", 191 leading.]
   Everything else in HEIGHTS is untouched. THE GOOGLE SHEET STILL CARRIES THE OLD THREE.

   v12 (2026-09-09), the weight axis and the two-option rate.
     - BAND_MIN_LO 24, BAND_MIN_HI 6. Every straddle band is at least this wide, below and above
       the boundary; the lo and hi the sheet authors still win wherever they are wider. The
       asymmetry is the shape the sheet already has: five of the six rows using lo/hi are wider
       below the flip than above, because a skier approaching the point where they need more ski
       is a real straddle and a skier who has just been given the longer one is not.
       [Scott, 2026-09-09: "I am comfortable with more two answers here than I originally thought.
       I think that is true for most people."]
     - the run above the flip is now a ladder, not a single jump: a boundary every TWO_UP_LB from
       the GENERIC flip, so weight keeps pulling instead of stopping after one move.
     - TWO_UP_OVERRIDE, one row. At 5'10" the jump is 41 lb, not 60. [Scott, 2026-09-09: 5'10"
       215 lb is a 186.] Every other height keeps 60, and that is deliberate: 6'0" flips at 168 lb
       and 6'1" at 228, so a jump under 60 anywhere near there puts a 6'0" skier on a longer ski
       than a 6'1" skier of the same weight. The 60 lb jump is what hides how far apart the flip
       weights are. Shortening it everywhere needs the flip column re-ruled first.
     Scores 106/106 on the headline and 43/43 on the second length against rulings.txt.

   v11 (2026-09-05), the last two hedged cases from Scott's ten-example review:
     - the 124 mm always-offer-the-longer rule needs a heavy skier (SOFT_UP_LB 180). A Jeffrey 124
       at 5'9" 170 lb is 181 alone.
     - the 6'2" pair band above the flip narrows from 30 lb to 25. A Billy Goat 114 at 6'2" 215 lb
       is 191 alone; 6'2" 210 lb still pairs, which is the tie-break that set the band.
     HEIGHTS row 74 changed. Mirror it into build_sheet.py and the Google Sheet.

   v10 (2026-09-05): the two waist thresholds now mean one thing each.
     WIDE_WAIST_MM 118 - the weight flip comes WIDE_SHIFT_LB earlier. Nothing else.
     SOFT_WAIST_MM 124 - the ski needs length: never offer a shorter pair, always offer the longer.
       The soft-core group, Jeffrey 124 and Cease and Desist.
     Before this, 118 did both jobs and put a second length in front of skiers on a Billy Goat 118
     and a Jeffrey 118 who did not need one.

   v9 (2026-09-05), three rulings from Scott's 150-case pass:
     - two up is measured from the GENERIC flip, never the 118+ early one (ruling 95)
     - when snapping already dragged the pick UP because the model is not built shorter, the
       118+ rule does not also offer the next size up (ruling 91)
     - when the rule wants more than one size shorter than the model is built, the engine
       DECLINES (noFit: 'short') instead of sizing. The ski is not built short enough for that
       skier and the tool must not pretend otherwise.
   Scores 102/102 on headline and 102/102 on pair against rulings.txt.

   READING THE TABLE
     b  base length for that height
     dp at or under this weight the shorter length is also shown, base leads
     F  weight where the pick moves one length up
     lo / hi  lb below / above F where both lengths show (below F the base leads, at or above F
              the longer leads). band = the same value for both.
     Beyond F + TWO_UP_LB: two up. Lighter never shortens. The pick is then snapped to the
     lengths the model is actually built in.
     Waist WIDE_WAIST_MM+ (Jeffrey 118/124, Billy Goat 118, Cease and Desist - softer, powder
     focused): the flip comes WIDE_SHIFT_LB earlier and the next length up is always in the
     answer; SOFT_WAIST_MM+ shows no shorter pair once the early flip has moved the pick up.
     Heights below 4'10" or above 6'6" read the end row of the table, which is what the Length
     Finder has always done. */
(function (window) {
  'use strict';
  

  var RULE_TABLE = {
    sheet: 'ON3P - Length Finder Sizing Rules',
    tab: 'HEIGHTS',
    exported: '2026-09-05',
    version: 'v10',         /* the HEIGHTS export. Four rows now differ from the live sheet:
                               6'2" pair band above the flip 30 -> 25 (logic v11), and the three
                               flips re-ruled on 2026-09-10, listed in the header. Edit the
                               HEIGHTS tab to match, then this line is true again. */
    logic: 'v15',            /* the rules around the table. v14 changed the rocker rule only: Ripper
                                on a Signature shape works from the Signature answer instead of
                                stepping a rung. v15 is one line on top of it: the Ripper ladder may
                                snap a skier DOWN onto its longest length but never UP onto its
                                shortest. [Scott, 2026-09-11.] Every Signature answer is still
                                byte-identical to v13. */

    heights: {
      58: { b: 161 }, 59: { b: 161 }, 60: { b: 161, F: 190, band: 10 }, 61: { b: 161, F: 188, band: 10 },
      62: { b: 161, F: 185, band: 10 }, 63: { b: 161, F: 190, band: 12 }, 64: { b: 161, F: 150, band: 10 },
      65: { b: 166, F: 155, band: 8 }, 66: { b: 171, dp: 135, F: 185, lo: 24, hi: 15 }, 67: { b: 171, F: 163, lo: 13, hi: 0 },
      68: { b: 176, dp: 150, F: 190, lo: 24, hi: 10 }, 69: { b: 176, F: 178, lo: 9, hi: 0 },
      70: { b: 176, F: 174, lo: 14, hi: 1 }, 71: { b: 181, F: 188, lo: 10, hi: 3 }, 72: { b: 181, F: 168, band: 6 },
      73: { b: 186, F: 220, band: 10 }, 74: { b: 186, F: 185, lo: 8, hi: 25 }, 75: { b: 191 }, 76: { b: 191 },
      77: { b: 191 }, 78: { b: 191 }
    },

    rules: {
      WIDE_WAIST_MM: 118,
      SOFT_WAIST_MM: 124,
      /* the soft-core skis offer the next size up for a heavy skier, not for everyone.
         [Scott, 2026-09-05: a Jeffrey 124 at 5'9" 170 lb is 181 alone; at 5'8" 200 lb it is
         181 with 186 (ruling 12), and a Cease and Desist at 6'1" 185 lb is 186 with 191
         (ruling 20).] Those three fix the threshold to somewhere in 171 to 185; 180 sits
         clear of both ends. */
      SOFT_UP_LB: 180,
      WIDE_SHIFT_LB: 20,
      /* the ladder above the flip: one more length every TWO_UP_LB, measured from the generic
         flip. TWO_UP_OVERRIDE replaces it for a single height where Scott has ruled otherwise. */
      TWO_UP_LB: 60,
      /* 5'10" needs a 41 lb jump for the 215 lb call; 5'8" needs an 80 lb one so that a 265 lb
         skier there still leads with the 181. Both are Scott's rulings, both are noted above. */
      TWO_UP_OVERRIDE: { 68: 80, 70: 41 },
      /* the narrowest a straddle band may be, below and above a boundary. The sheet's lo and hi
         win wherever they are wider. BAND_MIN_HI_OVERRIDE replaces the upper minimum for a single
         height. [Scott, 2026-09-10, on a Woodsman 108 at 5'7" 165 lb: "can live but I think this
         one probably 176."] That row authors hi 0, so the override restores the zero and the
         answer is 176 alone. */
      /* the only lengths Ripper Rocker is pressed in. A skier ordering Ripper is snapped to
         this ladder, intersected with what the model is built in, not to the model's own. */
      RIPPER_LENGTHS: [171, 176, 181, 186],
      BAND_MIN_LO: 24,
      BAND_MIN_HI: 6,
      BAND_MIN_HI_OVERRIDE: { 67: 0 },
      /* 6'0" and 6'1" author the narrowest bands in the table, 6 lb and 10 lb, and 24 lb is still
         not enough there: a 6'0" 200 lb skier was hearing 186 and nothing, while 6'2" at the same
         weight leads with 191. [Scott, 2026-09-10: "There are people 6'0" 205 and up that could
         ski 191cm. I think probably should it so that 6'0" 200 is getting 186 or 191. Same at
         6'1". Then swaps at 6'2". Then 6'1" 190 would also get 186 or 191."] The lead does not
         move on either row; only the band widens. */
      BAND_MIN_LO_OVERRIDE: { 72: 38, 73: 38 },
      NEIGHBOUR_DOWN_LB: 40,
      SHORT_NOTE_IN: 61,
      MAX_CM: 191,
      TABLE_MIN_IN: 58,
      TABLE_MAX_IN: 78,
      /* how far the snap may drag a skier UP before the model stops being a fit at all.
         One size (5 cm) is a snap and is said out loud. More than one size is a decline:
         the ski is not built short enough for this person and the tool must not size it.
         [Scott, 2026-09-05: "no 161 Oski (needs to go to Jeffrey 98)... needs to just say
         no ski available".] */
      SNAP_TOLERANCE_CM: 5
    },

    /* Accepted input window. Outside it the engine returns null. The rule saturates well
       inside these bounds, so clamping to them changes no answer the table can give. */
    range: { minHeightIn: 58, maxHeightIn: 80, minWeightLb: 60, maxWeightLb: 400 },

    /* One short clause per family and direction, for the one-line answer. Edit here, nowhere
       else. No exclamation points, no em dashes, no numbers. */
    reasons: {
      down: {
        'Mango': 'the shorter one swings quicker',
        'Jeffrey': 'the shorter one turns quicker in trees',
        'Woodsman': 'a directional ski skis longer than its number',
        'Billy Goat': 'a deep-snow ski mounted well back feels long',
        '': 'the shorter one turns quicker'
      },
      up: {
        'Mango': 'more ski under you for bigger jumps',
        'Jeffrey': 'more edge and more float at speed',
        'Woodsman': 'more stable at speed and in deep snow',
        'Billy Goat': 'the most float in the line',
        '': 'more edge and more float at speed'
      }
    }
  };

  var MODELS = {};

  function asc(a, b) { return a - b; }

  function isRipper(v) { return String(v || '').toLowerCase().indexOf('ripper') !== -1; }

  function registerModels(list) {
    if (!list || !list.length) return MODELS;
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (!m || !m.handle || !m.lengths || !m.lengths.length) continue;
      /* a length is either a number, or { cm: 181, stock: false } for a length the mould
         supports but the line does not carry in stock. Tours are all custom orders, so on a
         Tour page every length reads as a custom order; on a stock page only stock: false does. */
      var lens = [], stock = {}, j;
      for (j = 0; j < m.lengths.length; j++) {
        var raw = m.lengths[j];
        var n = Number(raw && raw.cm != null ? raw.cm : raw);
        if (!isFinite(n) || n <= 0 || lens.indexOf(n) !== -1) continue;
        lens.push(n);
        stock[n] = (raw && raw.cm != null) ? raw.stock !== false : true;
      }
      if (!lens.length) continue;
      lens.sort(asc);
      MODELS[m.handle] = {
        handle: m.handle,
        family: m.family || '',
        waistMm: Number(m.waistMm) || 0,
        lengths: lens,
        stock: stock,
        /* the profile this shape is BUILT with. Anything that is not Ripper is treated the same,
           because Signature Pow is a heat-modified pressing in the Signature mould. */
        stockRocker: isRipper(m.stockRocker) ? 'Ripper' : 'Signature',
        /* whether this shape can be ordered in Ripper at all. Default true, so a surface that has
           not been told stays where it was; the ones that cannot are named by each surface. */
        ripperOk: m.ripperOk !== false
      };
    }
    return MODELS;
  }

  function knows(handle) { return Object.prototype.hasOwnProperty.call(MODELS, handle); }

  function reasonFor(family, dir) {
    var set = RULE_TABLE.reasons[dir] || RULE_TABLE.reasons.up;
    return set[family] || set[''];
  }

  function on3pSize(input) {
    if (!input) return null;
    var M = MODELS[input.handle];
    if (!M) return null;

    var heightIn = Number(input.heightIn), weightLb = Number(input.weightLb);
    if (!isFinite(heightIn) || !isFinite(weightLb)) return null;
    var R = RULE_TABLE.range;
    if (heightIn < R.minHeightIn || heightIn > R.maxHeightIn) return null;
    if (weightLb < R.minWeightLb || weightLb > R.maxWeightLb) return null;

    var C = RULE_TABLE.rules;

    /* rocker first, because it decides which ladder everything below is measured against */
    var stockRocker = M.stockRocker || 'Signature';
    var ordered = input.rocker != null ? (isRipper(input.rocker) ? 'Ripper' : 'Signature') : stockRocker;
    if (ordered === 'Ripper' && M.ripperOk === false) ordered = 'Signature';   /* not offered here */

    var lens = M.lengths;
    if (ordered === 'Ripper') {
      /* the ladder is what this shape is built in, intersected with what Ripper is pressed in */
      var rl = M.lengths.filter(function (L) { return C.RIPPER_LENGTHS.indexOf(L) !== -1; });
      if (rl.length) { lens = rl; } else { ordered = stockRocker; }
    }
    /* the v14 rocker move applies only when Ripper is ordered on a shape not built that way.
       A shape built as Ripper answers on its own ladder and is never adjusted. */
    var rockerStep = (ordered === 'Ripper' && stockRocker !== 'Ripper');
    var k = Math.max(C.TABLE_MIN_IN, Math.min(C.TABLE_MAX_IN, Math.round(heightIn)));
    var p = RULE_TABLE.heights[k], B = p.b;
    var wide = M.waistMm >= C.WIDE_WAIST_MM;
    var F = p.F != null ? (wide ? p.F - C.WIDE_SHIFT_LB : p.F) : null;
    var lo = p.lo != null ? p.lo : p.band, hi = p.hi != null ? p.hi : p.band;
    /* the band the customer actually gets, and the rung length for this height */
    var minHi = C.BAND_MIN_HI_OVERRIDE[k] != null ? C.BAND_MIN_HI_OVERRIDE[k] : C.BAND_MIN_HI;
    var minLo = C.BAND_MIN_LO_OVERRIDE[k] != null ? C.BAND_MIN_LO_OVERRIDE[k] : C.BAND_MIN_LO;
    var loB = Math.max(lo || 0, minLo), hiB = Math.max(hi || 0, minHi);
    var jump = C.TWO_UP_OVERRIDE[k] != null ? C.TWO_UP_OVERRIDE[k] : C.TWO_UP_LB;

    /* the generic answer for this height and weight, before snapping. Weight is a parameter
       rather than a closure read, because v14 has to ask the same question at other weights. */
    function tableRaw(flip, lbs) {
      var prim = B, sec = null;
      if (p.dp != null && lbs <= p.dp) { sec = B - 5; return { prim: prim, sec: sec }; }
      if (flip == null) return { prim: prim, sec: sec };

      /* at and below the flip, unchanged since v8 apart from the wider band */
      if (lbs < flip - loB) return { prim: B, sec: null };
      if (lbs < flip) return { prim: B, sec: B + 5 };
      if (lbs <= flip + hiB) return { prim: B + 5, sec: B };

      /* above it, a ladder. Every boundary after the first is measured from the GENERIC flip,
         never the early 118+ one: the wide shift moves the one-size flip, it does not make the
         later jumps come earlier too. [Scott, ruling 95.] */
      var g = p.F != null ? p.F : flip;
      var rung = Math.max(1, Math.floor((lbs - g) / jump) + 1);
      prim = B + 5 * rung;
      var passed = g + (rung - 1) * jump, next = g + rung * jump;
      if (rung >= 2 && lbs - passed <= hiB) { sec = prim - 5; }
      else if (next - lbs <= loB) { sec = prim + 5; }
      return { prim: prim, sec: sec };
    }

    function snapTo(ls, x) {
      return ls.reduce(function (a, l) { return Math.abs(l - x) < Math.abs(a - x) ? l : a; }, ls[0]);
    }

    /* the plain neighbour a single-length answer carries, so the surfaces always have something
       to name in the "works too" line. Not an option: strength is what promotes it to one. */
    function neighbourFor(ls, primary, lbs) {
      var i = ls.indexOf(primary), up = ls[i + 1], down = ls[i - 1];
      var light = F != null ? lbs < F - loB - C.NEIGHBOUR_DOWN_LB : (B >= C.MAX_CM);
      var n = (!light || down == null) ? (up != null ? up : down) : down;
      return n === undefined ? null : n;
    }

    /* the whole rule for one weight against one ladder. This is the Signature answer when it is
       handed M.lengths, which is exactly how v14 gets one to work from. */
    function solve(ls, lbs) {
      var t = tableRaw(F, lbs);
      var sec = t.sec, strength = sec != null;
      var wanted = Math.min(t.prim, C.MAX_CM);

      /* The model is not built short enough for this skier. Do not size it. */
      if (ls[0] - wanted > C.SNAP_TOLERANCE_CM) {
        return { noFit: 'short', wanted: wanted, shortestBy: ls[0] - wanted,
                 primary: null, secondary: null, strength: false };
      }

      var primary = snapTo(ls, wanted);
      var secondary = sec != null ? snapTo(ls, Math.min(sec, C.MAX_CM)) : null;
      if (secondary === primary) { secondary = null; strength = false; }

      var i = ls.indexOf(primary), up = ls[i + 1];

      if (wide) {                                   /* the earlier flip may have moved the pick up */
        var generic = snapTo(ls, Math.min(tableRaw(p.F, lbs).prim, C.MAX_CM));
        if (generic < primary) {                    /* it did: 118 keeps the generic pick as the pair; 124+ needs the length */
          if (M.waistMm >= C.SOFT_WAIST_MM) { secondary = null; strength = false; }
          else { secondary = generic; strength = true; }
        } else if ((secondary == null || secondary < primary) && up != null && primary <= wanted &&
                   M.waistMm >= C.SOFT_WAIST_MM && lbs >= C.SOFT_UP_LB) {
          /* Always offering the next size up belongs to the SOFT_WAIST group (124 mm: Jeffrey 124 and
             Cease and Desist), not to everything 118 mm and wider. [Scott, 2026-09-05: a Billy Goat 118
             at 181 is already more ski than a Jeffrey 118 at 181, because the mount sits 6 cm further
             back. Effective edge is sidecut engagement length and speaks to hard snow, not to how a
             powder ski turns.] Restated with him: rulings 15, 19, 51, 84, 90 and 95.
             Not applied when snapping already moved the pick up, because that skier is on more ski
             than the rule asked for. [Scott, ruling 91.] */
          secondary = up; strength = true;
        }
      }

      if (secondary == null) secondary = neighbourFor(ls, primary, lbs);
      return { noFit: null, primary: primary, secondary: secondary, strength: strength, wanted: wanted };
    }

    /* what the customer actually reads, so two answers can be compared as printed rather than
       as objects. The strip and the Length Finder both gate the second length on strength. */
    function printed(r) {
      if (!r || r.noFit) return 'n';
      return (r.strength && r.secondary != null && r.secondary !== r.primary)
        ? (r.primary + '/' + r.secondary) : ('' + r.primary);
    }

    /* ---------------------------------------------------------------------------------------
       v14 ROCKER. Ripper on a Signature shape no longer steps a rung. It starts from the
       SIGNATURE answer and moves it only where the skier is light for their height, so a
       heavier skier's Ripper sizing holds to Signature. [Scott, 2026-09-10: "I just want to
       make sure that the heavier skiers sizing holds more closely to signature when they
       choose ripper."]

         1. Signature answer already two lengths: keep both, do nothing further.
            [Scott: "I think it keeps the two and does nothing further."]
         2. Signature answer a single length L: find the run of weights at this height and model
            that print L alone. Lighter half of that run, the answer becomes L with L-5 alongside,
            THE LONGER LENGTH LEADING. Heavier half, L unchanged.
            [Scott, 2026-09-10, on the ordering: "yes I think longer length leads." Lighter-first
            was measured and broke monotonicity in 120 cells: a 5'10" 185 lb skier would have led
            on 176 while a 180 lb skier led on 181.]
         3. The topmost and bottommost runs in a height row never step. They are the open ends of
            the row rather than a band with two halves, and the people in them are the heaviest
            and the lightest at their height. [Scott, 2026-09-10: "ok makes sense."]
         4. Then the Ripper ladder. A length Ripper is not pressed in is never named.
       --------------------------------------------------------------------------------------- */
    function ripperWant(sigR) {
      if (sigR.strength && sigR.secondary != null && sigR.secondary !== sigR.primary) {
        return [sigR.primary, sigR.secondary];                                 /* rule 1 */
      }
      var L = sigR.primary, key0 = printed(sigR);
      var W0 = RULE_TABLE.range.minWeightLb, W1 = RULE_TABLE.range.maxWeightLb;
      var runLo = weightLb, runHi = weightLb;
      while (runLo > W0 && printed(solve(M.lengths, runLo - 1)) === key0) runLo--;
      while (runHi < W1 && printed(solve(M.lengths, runHi + 1)) === key0) runHi++;
      if (runLo <= W0 || runHi >= W1) return [L];                              /* rule 3 */
      if (weightLb * 2 > runLo + runHi) return [L];                            /* rule 2, heavier half */
      return [L, L - 5];                                                       /* rule 2, lighter half */
    }

    var res, wanted, primary, secondary, strength, atLongEnd, snappedUp, adjusted;

    if (!rockerStep) {
      res = solve(lens, weightLb);
      if (res.noFit) return declined(res);
      wanted = res.wanted;
      primary = res.primary; secondary = res.secondary; strength = res.strength;
      atLongEnd = wanted > lens[lens.length - 1];
      snappedUp = primary > wanted;
      adjusted = false;
    } else {
      var sigR = solve(M.lengths, weightLb);
      if (sigR.noFit) return declined(sigR);            /* Signature already declines: so does Ripper */
      wanted = sigR.wanted;
      var want = ripperWant(sigR);
      var shortest = lens[0], longest = lens[lens.length - 1];
      var keep = want.filter(function (L) { return lens.indexOf(L) !== -1; });
      var droppedShort = false, droppedLong = false;
      want.forEach(function (L) { if (L < shortest) droppedShort = true; if (L > longest) droppedLong = true; });

      if (keep.length) {
        primary = keep[0];
        strength = keep.length > 1;
        secondary = strength ? keep[1] : neighbourFor(lens, primary, weightLb);
      } else if (sigR.primary > longest) {
        /* wanted more ski than Ripper is pressed in. Snapping DOWN is safe: the skier ends up on
           less ski than the rule asked for, which is the direction a Ripper is already going. */
        primary = longest; strength = false; secondary = neighbourFor(lens, primary, weightLb);
      } else {
        /* wanted LESS ski than Ripper is pressed in, and nothing the Signature answer named
           survives the ladder. This used to snap up one size to the 171, the same tolerance the
           shape's own floor gets. It does not any more.
           [Scott, 2026-09-11: "171cm Ripper is too long for this person. We have no ripper option
           for them... a 191 can snap down to a 186 ripper, but a 166 cannot snap up to a 171
           ripper. It is too much."]
           The asymmetry is the point, and it costs nothing: the same ski in Signature does size
           this skier, and the decline copy sends them one dropdown up to get it.
           Note this is only reached when NOTHING survives. A Signature answer of "171 or 166"
           still keeps its 171, because the skier was already being offered that length. */
        return declined({ wanted: wanted, shortestBy: shortest - wanted });
      }
      /* the end-of-ladder lines have to fire when the LADDER dropped a length, not only when the
         table asked for one outside the model. Without this a 5'5" 150 lb skier reads a bare 171
         and is never told 171 is as short as Ripper is pressed. */
      atLongEnd = droppedLong || wanted > longest;
      snappedUp = droppedShort || primary > wanted;
      adjusted = printed({ primary: primary, secondary: secondary, strength: strength }) !== printed(sigR);
    }

    function declined(r) {
      return {
        primary: null, secondary: null, strength: false, reason: '',
        lengths: lens.slice(), dir: 'down', shortNote: false,
        handle: M.handle, family: M.family,
        noFit: 'short', wanted: r.wanted,
        shortestBy: r.shortestBy,
        rocker: ordered, stockRocker: stockRocker, rockerAdjusted: false,
        atLongEnd: false, snappedUp: false,
        primaryStock: null, secondaryStock: null
      };
    }

    if (secondary === undefined) secondary = null;
    var dir = secondary != null && secondary > primary ? 'up' : 'down';

    return {
      rocker: ordered,
      stockRocker: stockRocker,
      rockerAdjusted: adjusted,
      primary: primary,
      secondary: secondary,
      strength: strength,
      reason: secondary != null ? reasonFor(M.family, dir) : '',
      lengths: lens.slice(),
      dir: dir,
      shortNote: heightIn < C.SHORT_NOTE_IN && primary === lens[0] && lens[0] <= 161,
      handle: M.handle,
      family: M.family,
      noFit: null,
      /* the rule wanted more ski than this shape is built in, or the Ripper ladder dropped the
         longer of two lengths. Not a miss: say it is the longest one built.
         [Scott, 2026-09-05: "should say longest we build in this shape".] */
      atLongEnd: atLongEnd,
      /* the rule wanted one size shorter than the ladder goes. Snapped, and said out loud. */
      snappedUp: snappedUp,
      wanted: wanted,
      primaryStock: M.stock[primary] !== false,
      secondaryStock: secondary != null ? M.stock[secondary] !== false : null
    };
  }

  on3pSize.registerModels = registerModels;
  on3pSize.knows = knows;
  on3pSize.ruleTable = RULE_TABLE;

  window.on3pSize = on3pSize;
})(window);
